import { currentDeviceReducer } from "./current-device/reducers";
import { fullDeviceReducer } from "./full-devices/reducers";
import { fullscreenViewReducer } from "./fullscreen-view";
import { sidebarReducer } from "./sidebar";
import { versionsReducer } from "./versions/reducers";

// Define the ui-state store.
const globalPageReducers = {
  currentDevice: currentDeviceReducer,
  fullDevices: fullDeviceReducer,
  fullscreenView: fullscreenViewReducer,
  sidebar: sidebarReducer,
  versions: versionsReducer,
};

export { globalPageReducers };
